///
/// EarthBrowser
///
/// Created by Matt Giger on 10/12/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Top-right chrome cluster: the Views / Share pair for the current view
/// and the account menu. One positioned wrapper so the shells share the
/// corner and the notification slot can reserve room for them.
///

import { AccountMenu } from "./AccountMenu"
import { ViewActions } from "./ViewActions"

interface TopRightControlsProps {
	/** Long-press on the account pill unlocks the developer tools */
	onDevtoolsUnlock?: () => void
}

export function TopRightControls({ onDevtoolsUnlock }: TopRightControlsProps) {
	return (
		<div
			className="absolute z-30 flex items-center gap-2"
			style={{
				// Clear the status bar / Dynamic Island in the native apps and
				// notched browsers (viewport-fit=cover); mirrors TopLeftControls
				top: "calc(0.5rem + var(--safe-area-inset-top))",
				right: "calc(0.5rem + var(--safe-area-inset-right))",
			}}
		>
			<ViewActions />
			<AccountMenu onDevtoolsUnlock={onDevtoolsUnlock} />
		</div>
	)
}
